import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BuscadorPipe } from '../../pipes/buscador.pipe';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import { ItemGeneralListado } from '../itemClasses/itemListadoGeneral.class';

@Component({
  selector: 'listado-general',
  templateUrl: './generalList.component.html'
})
export class ListadoComponent implements OnInit, OnDestroy {
  @Output() clickNuevo: EventEmitter<any> = new EventEmitter();
  @Output() itemClicked: EventEmitter<any> = new EventEmitter();

  @Input('listado') listado: Observable<ItemGeneralListado[]>;
  @Input('titulo') titulo: String;
  @Input('urladicional') urladicional: String = '';
  @Input('clickBack') clickBack: boolean = false;
  @Input('leyendaListado') leyendaListado: String = '';
  @Input('ocultarNuevo') ocultarNuevo = false;
  @Input('modoIconosOn') modoIconosOn = false;
  @Input('imagenClass') imagenClass = '';
  @Input('capturarClickItem') capturarClickItem = false;

  listadoNoFiltrado: ItemGeneralListado[];
  listadoFiltrado: ItemGeneralListado[];
  buscarListado: String = '';
  itemHover: ItemGeneralListado;

  private allItems: any[];
  paginador: any = {};
  items: ItemGeneralListado[] = new Array<ItemGeneralListado>();
  cargando: Boolean = false;
  subscription: Subscription;

  constructor(private router: Router, private aRoute: ActivatedRoute) {}

  ngOnInit() {
    const listadoComp = this;
    // this.cargando = true;

    this.subscription = this.listado.subscribe(function(data) {
      listadoComp.listadoNoFiltrado = data;
      listadoComp.filtrarListado();
      listadoComp.cargando = false;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Funcion que se llama cuando el boton Nuevo es clickeado,
   * el proposito de esta funcion es propagar dicho evento
   * para que pueda ser capturado por algun componente padre.
   */
  onClickNuevo() {
    this.clickNuevo.emit();
  }

  onClickItem(item) {
    if(item.UrlDestination == undefined ){
      const local: string =
        (this.router.url as string) + '/' + item.id + (this.urladicional || '');
      if (!this.capturarClickItem) {
        this.router.navigateByUrl(local);
        return;
      }
      this.itemClicked.emit(item);
    }else{
      const local: string =
        (this.router.url as string) + '/' + item.UrlDestination;
      if (!this.capturarClickItem) {
        this.router.navigateByUrl(local);
        return;
      }
      this.itemClicked.emit(item);
    }
  }

  filtrarListado() {
    this.listadoFiltrado = this.listadoNoFiltrado.filter(
      item =>
        item.Titulo.toUpperCase().indexOf(this.buscarListado.toUpperCase()) !==
        -1
    );
    this.setPage(1);
  }
  setPage(nroPagina: number) {
    this.cargando = true;
    this.paginador = this.getPager(this.listadoFiltrado.length, nroPagina);
    if (
      nroPagina < 1 ||
      (nroPagina > this.paginador.totalPaginas &&
        this.paginador.totalPaginas !== 0)
    ) {
      return;
    }
    this.items = this.listadoFiltrado.slice(
      this.paginador.startIndex,
      this.paginador.endIndex + 1
    );
    this.cargando = false;
  }
  getPager(
    totalItems: number,
    paginaActual: number = 1,
    catidadPorPagina: number = 9
  ) {
    const totalPaginas = Math.ceil(totalItems / catidadPorPagina);

    let startPagina: number, endPagina: number;
    if (totalPaginas <= 10) {
      startPagina = 1;
      endPagina = totalPaginas;
    } else {
      if (paginaActual <= 6) {
        startPagina = 1;
        endPagina = 10;
      } else if (paginaActual + 4 >= totalPaginas) {
        startPagina = totalPaginas - 9;
        endPagina = totalPaginas;
      } else {
        startPagina = paginaActual - 5;
        endPagina = paginaActual + 4;
      }
    }

    // Calcular los índices de elementos iniciales y finales
    const startIndex = (paginaActual - 1) * catidadPorPagina;
    const endIndex = Math.min(
      startIndex + catidadPorPagina - 1,
      totalItems - 1
    );

    // create an array of pages to ng-repeat in the pager control
    const paginas: number[] = new Array();
    for (let index = startPagina; index < endPagina + 1; index++) {
      paginas.push(index);
    }

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      paginaActual: paginaActual,
      catidadPorPagina: catidadPorPagina,
      totalPaginas: totalPaginas,
      startPagina: startPagina,
      endPagina: endPagina,
      startIndex: startIndex,
      endIndex: endIndex,
      paginas: paginas
    };
  }
  volver() {
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/generalList/generallist.component.ts